import {
  DesignProp,
  GeneralProp,
} from "@/react/components/shared/BuilderUI/constants/PropCategories";

export type AlignmentOption = "left" | "center" | "right";

export const objectAlignment = {
  prop: "children",
  name: "Alignment",
  nameI18n: "builder_ui.prop_type.styles.alignment",
  category: [DesignProp, GeneralProp],
  type: "button",
  defaultValue: "center",
  alignment_options: [
    {
      type: "left",
      icon: "20-align-object-left",
    },
    {
      type: "center",
      icon: "20-align-object-center",
    },
    {
      type: "right",
      icon: "20-align-object-right",
    },
  ],
} as const;
